import { Space, Table } from "antd";
import { useLazyGetAnswersQuery } from "api";
import { Answer } from "models";
import { useEffect } from "react";

interface TableUsersExpandableProps {
	userId: string;
}
export const TableUsersExpandable = ({ userId }: TableUsersExpandableProps) => {
	const [getAnswers, { data: answers, isLoading }] = useLazyGetAnswersQuery();

	useEffect(() => {
		if (!userId) return;

		getAnswers({ userId });
	}, [userId, getAnswers]);

	return (
		<Table
			pagination={{
				showSizeChanger: true,
				hideOnSinglePage: true,
			}}
			dataSource={answers?.map((item, key) => ({ ...item, key: ++key }))}
			scroll={{ x: true }}
			loading={isLoading}
			style={{ whiteSpace: "nowrap" }}>
			<Table.Column title="STT" dataIndex="key" />
			<Table.Column<Answer>
				title="Phân mục"
				render={(_, record) => {
					return <div style={{ maxWidth: 400, whiteSpace: "break-spaces" }}>{record?.question.category}</div>;
				}}
			/>
			<Table.Column<Answer>
				title="Câu hỏi "
				render={(_, record) => {
					return <Space style={{ width: 400, whiteSpace: "break-spaces" }}>{record?.question.question}</Space>;
				}}
			/>
			<Table.Column<Answer>
				title="Câu trả lời"
				render={(_, record) => {
					return (
						<div style={{ maxWidth: 400, whiteSpace: "break-spaces" }}>
							{record?.question.isRequired ? record?.answer.split("=").length > 1 ? record?.answer.split("=")[1] : record?.answer : <Space direction="vertical">{record?.answer}</Space>}
						</div>
					);
				}}
			/>
		</Table>
	);
};
